import PostListPage from '~components/post-list-page'

export default PostListPage({
  path: '/top',
  title: 'Top post',
  sort: '-karma'
})



// WEBPACK FOOTER //
// ../frontend/pages/post/list-top.js